import './App.css';
import About from './components/About/About';

import Home from './components/Home/Home';
import Portfolio from './components/Portfolio/Portfolio';
import AnimatedCursor from "react-animated-cursor"
import Blog from './components/Blog/Blog';
import Contact from './components/Contact/Contact';



function App() {
  return (
    <div>
      <AnimatedCursor />
      <Home></Home>
      <About></About>
      <Portfolio></Portfolio>
      <Blog></Blog>
      <Contact></Contact>
    </div>
  );
}

export default App;
